module.exports = __webpack_public_path__ + "dcee1ce14b5c5dd4d9b1a8975a4a6ce5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/calculator-s.png
// module id = 2614
// module chunks = 0